import React from "react";
import { business } from "@/lib/business";
import { useSeo } from "@/lib/seo";

/**
 * Shared layout for Terms / Privacy / Refund policy pages.
 * Renders a wide-line-height prose column with a clear heading + "last updated" line.
 */
export default function LegalPage({ title, subtitle, children, testId, seoDescription }) {
  useSeo({
    title: `${title} — NovalynxTech`,
    description: seoDescription || subtitle || `${title} for NovalynxTech customers.`,
    canonical: typeof window !== "undefined" ? window.location.href.split("?")[0] : "",
  });
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid={testId}>
      <div className="mb-10">
        <p className="text-xs uppercase tracking-widest text-primary font-semibold mb-3">Legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-3">{title}</h1>
        {subtitle && <p className="text-lg text-muted-foreground">{subtitle}</p>}
        <p className="text-xs text-muted-foreground mt-4">
          Last updated {business.lastUpdated}
        </p>
      </div>
      <div className="prose-legal space-y-6 text-sm leading-relaxed text-foreground/90">
        {children}
      </div>
    </div>
  );
}

// Helper components used across all legal pages for consistent styling
export function Section({ n, title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl font-bold mt-8 mb-3 text-white">
        {n && <span className="text-primary mr-2">{n}.</span>}{title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
